import { takeLatest, all, call, put } from "redux-saga/effects";

import { request } from "@app/services";
import {
  dashboard,
  dashboardFailed,
  dashboardSuccess,
  nonParentCategories,
  nonParentCategoriesFailed,
  nonParentCategoriesSuccess,
  getTestimonials,
  getTestimonialsFailed,
  getTestimonialsSuccess,
} from "./slice";
import * as endPoints from "./endpoints";

function* getUserDashBoardSaga({ payload }: ReturnType<typeof dashboard>): any {
  try {
    const { carType }: any = payload;
    const fullUrl = carType
      ? `${endPoints.userDashboard}?carType=${carType}`
      : endPoints.userDashboard;
    const response = yield call(request.get, fullUrl);
    yield put(dashboardSuccess(response?.data));
  } catch (error: any) {
    yield put(dashboardFailed(error));
  }
}

//--------------------FindTestDriveSaga-------------------------

function* nonParentCategoriesSaga(
  action: ReturnType<typeof nonParentCategories>
): any {
  try {
    const response = yield call(
      request.get,
      `${endPoints.nonParentCategories}`
    );
    yield put(nonParentCategoriesSuccess(response.data));
  } catch (error: any) {
    yield put(nonParentCategoriesFailed(error));
  }
}

//--------------------GetTestimonialsSaga-------------------------

function* getTestimonialsSaga(
  action: ReturnType<typeof getTestimonials>
): any {
  try {
    const response = yield call(request.get, endPoints.testimonials);
    yield put(getTestimonialsSuccess(response?.data ?? response));
  } catch (error: any) {
    yield put(getTestimonialsFailed(error));
  }
}

function* userDashboardSagas() {
  yield all([takeLatest(dashboard, getUserDashBoardSaga)]);
  yield all([takeLatest(nonParentCategories, nonParentCategoriesSaga)]);
  yield all([takeLatest(getTestimonials, getTestimonialsSaga)]);
}

export { userDashboardSagas };
